"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "../AutoVerkaufen.css";

import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";
import { TopSectionAutoVerkaufen } from "../sections/TopSection";
import { AutoVerkaufenGrid } from "../../../common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";
import höchstenPreis from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-verkauf.avif";
import vonZuhauseAus from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-hoechstpreis.avif";
import verifizierteAngebote from "@/assets/auto-verkaufen/wir-kaufen-dein-auto-abholung.avif";
import { fragenWirkaufendeinauto } from "../data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import Link from "next/link";

// Only needed after step 11; keep auth-related code/CSS out of initial paint.
// Below-the-fold section; defer to reduce initial route JS/CSS.
const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function Wirkaufendeinauto() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionAutoVerkaufen
        title="Wir kaufen dein Auto? Besser verkaufen & mehr bekommen"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*
            <br /> Verkaufe dein Auto und erhalte mehr Geld.
          </>
        }
        customNav="Auto verkaufen"
        customNavLink="/auto-verkaufen"
        linkname="Wir kaufen dein Auto"
        link="/auto-verkaufen/wir-kaufen-dein-auto"
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen/wir-kaufen-dein-auto"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color AV-below-fold">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Wir kaufen dein Auto nicht, wir verkaufen es für dich – zum besten Preis!"
              leftText={
                <>
                  <p>
                    Bei Autoeinfachlos stellen wir sicher, dass du den
                    bestmöglichen Preis für dein Auto erzielst. Mit nur einem
                    Klick erreichst du unser Netzwerk von über 5.000 Händlern in
                    ganz Österreich. Diese Händler konkurrieren um dein
                    Fahrzeug, und wir sichern dir das Höchstgebot, indem wir
                    dein Auto an den Händler mit dem besten Angebot
                    weitervermitteln.
                  </p>
                  <p>
                    <strong>Vorteile unseres Verkaufsprozesses:</strong>
                  </p>

                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Höchster Verkaufspreis für dein Auto</strong>
                      <br />
                      Dank unseres Auktionsmodells konkurrieren täglich über
                      5.000 geprüfte Händler um dein Fahrzeug.
                    </li>
                    <li>
                      <strong>Bequemer Ablauf von zu Hause aus</strong>
                      <br />
                      Alles läuft digital ab – von der Bewertung bis hin zum
                      Verkauf musst du dein Haus nicht verlassen.
                    </li>
                    <li>
                      <strong>Kostenlose Abholung und Sofortzahlung</strong>
                      <br />
                      Sobald du ein Angebot akzeptierst, organisiert der Händler
                      die kostenlose Abholung direkt bei dir zu Hause.
                    </li>
                    <li>
                      <strong>Keine versteckten Kosten oder Gebühren</strong>
                      <br />
                      Das Höchstgebot wird dir vollständig und ohne Abzüge
                      angezeigt.
                    </li>
                    <li>
                      <strong>Schneller Verkauf</strong>
                      <br />
                      Dein Auto kann innerhalb von 24 Stunden zum Höchstpreis
                      verkauft werden.
                    </li>
                  </ul>
                </>
              }
              rightFirstTitle="Was macht Autoeinfachlos anders als Wir kaufen dein Auto?"
              rightFirstText={
                <>
                  <p>
                    Während Wirkaufendeinauto Autos zu einem niedrigeren Preis
                    ankauft und gewinnbringend weiterverkauft, setzt
                    Autoeinfachlos auf einen anderen Ansatz.
                  </p>
                  <p>
                    Wir vermitteln dein Auto innerhalb von 24 Stunden an einen
                    geprüften Händler in ganz Österreich, der bereit ist, den
                    besten Preis zu zahlen.
                  </p>
                  <p>
                    Stell dir unseren Service so vor, als würdest du jeden
                    Händler in Österreich kontaktieren und nach dem besten
                    Angebot fragen, um dein Auto schließlich an den
                    Höchstbietenden zu verkaufen. Genau das machen wir für dich
                    – und das mit nur einem Klick.
                  </p>
                  <p>
                    Erfahre mehr über{" "}
                    <Link
                      className="AV-link-white transition"
                      href="/auto-verkaufen/ratgeber/wirkaufendeinauto-alternative"
                    >
                      Wirkaufendeinauto Alternativen
                    </Link>
                  </p>
                </>
              }
              rightSecondTitle="Wir kaufen dein Auto besser! "
              rightSecondText={
                <>
                  <p>
                    Höchstpreise statt Direktverkauf: Beim Direktverkauf liegt
                    das Interesse des Käufers meist an einem möglichst niedrigen
                    Preis, da das Auto später gewinnbringend weiterverkauft
                    wird.
                  </p>
                  <p>
                    Bei Autoeinfachlos ist es anders: Wir vermitteln dein
                    Fahrzeug an über 5.000 geprüfte Händler, die in einer
                    Auktion um dein Auto bieten. So erzielst du den
                    bestmöglichen Preis, anstatt es günstig zu verkaufen. Unser
                    Ziel ist es, dein Auto einfach, fair und schnell zum besten
                    Preis zu verkaufen.
                  </p>
                  <p>
                    Erfahre wie es funktioniert:{" "}
                    <Link
                      className="AV-link-blue transition"
                      href="/so-funktionierts"
                    >
                      So funktioniert´s
                    </Link>
                  </p>
                </>
              }
            />
            <div className="Banner-sections">
              <BildTextInfo
                image={höchstenPreis}
                h2
                isBig
                title="Vermittlung statt Verkauf"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos eine Alternative zu „Wir kaufen dein Auto“ zu finden."
                text={
                  <>
                    <p>
                      Bei vielen Ankaufsplattformen steht der Direktverkauf im
                      Mittelpunkt – das bedeutet, dass dein Auto zu einem oft
                      niedrigen Ankaufspreis gekauft wird, um es später mit
                      Gewinn weiterzuverkaufen. Bei Autoeinfachlos läuft es
                      anders: Wir kaufen dein Auto nicht selbst, sondern
                      vermitteln es an über 5.000 geprüfte Händler in ganz
                      Österreich. Diese Händler bieten in einer Auktion um dein
                      Fahrzeug, was dir die Möglichkeit gibt, den echten
                      Marktwert zu erzielen.
                    </p>

                    <p>
                      Unser Fokus liegt darauf, dir den Höchstpreis zu sichern,
                      nicht darauf, dein Auto günstig zu kaufen.
                    </p>
                  </>
                }
              />
              <BildTextInfo
                image={vonZuhauseAus}
                revert
                isBig
                h2
                title="Höchstpreis statt Ankaufspreis"
                alt="Frau lächelt und schaut auf ihr Smartphone, während sie den Höchstpreis für den Verkauf ihres Autos über Autoeinfachlos ermittelt"
                text={
                  <>
                    <p>
                      Ankaufsplattformen zahlen oft einen reduzierten Preis für
                      dein Fahrzeug, um später beim Weiterverkauf Gewinn zu
                      machen. Bei Autoeinfachlos funktioniert das anders: Durch
                      unser Auktionsmodell bieten Händler direkt um dein Auto,
                      was den Preis nach oben treibt.
                    </p>
                    <p>
                      So entsteht echter Wettbewerb, der dir garantiert den
                      Höchstpreis sichert – statt eines standardisierten
                      Ankaufspreises, der unter dem Marktwert liegt. Mit
                      Autoeinfachlos bekommst du genau das, was dein Auto
                      wirklich wert ist.
                    </p>
                  </>
                }
              />
              <BildTextInfo
                image={verifizierteAngebote}
                title="Abholung statt Filialenbesuch"
                h2
                isBig
                alt="Ein Smartphone mit einem Verkaufsangebot für ein Auto, als Alternative zur Plattform Wir kaufen dein Auto"
                text={
                  <>
                    <p>
                      Ein weiterer Vorteil bei Autoeinfachlos ist die kostenlose
                      Abholung deines Autos. Während viele Ankaufsplattformen
                      verlangen, dass du dein Fahrzeug in einer Filiale
                      vorbeibringst, organisieren wir eine Abholung direkt bei
                      dir zu Hause, am Arbeitsplatz oder an einem anderen Ort,
                      der dir passt.
                    </p>
                    <p>
                      <strong>Das bedeutet: </strong>Kein Zeitaufwand, keine
                      Umstände – wir machen den Verkaufsprozess für dich so
                      bequem wie möglich. Du musst dich um nichts kümmern, außer
                      das beste Angebot auszuwählen.
                    </p>
                  </>
                }
              />
            </div>

            {/* <div>Trustpolit kommt hier</div> */}
            <HäufigeFragen
              title="Häufig gestellte Fragen (FAQ)"
              fragen={fragenWirkaufendeinauto}
              image={FAQImage}
            />
            <Ratgeber
              title="Mehr zum Thema Wir kaufen dein Auto"
              wirkaufendeinautoAlternative
              autoVerkaufen
              autoBewerten
              listenpreisBerechnen
              fahrgestellnummerPruefen
              kaputtesAuto
            />
          </div>
          <Banner title="Verkaufe dein Auto auf die Autoeinfachlos-Art" h2 />
        </div>
      )}
    </div>
  );
}

export default Wirkaufendeinauto;
